var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-info"},[(_vm.user)?_c('div',{staticClass:"user-info__wrap"},[_c('user-info-header'),_c('UserData'),_c('UserContact'),_c('UserLanguage'),_c('userChangePassword')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }